import React from 'react';
import { Box, CircularProgress, Dialog, DialogContent, Divider, Typography } from '@mui/material';

import { string } from 'prop-types';

import MagellanLogoColored from '../icon/MagellanLogoColored';

const AuthDialog = ({ message }) => {
  return (
    <Dialog
      onClose={() => {}}
      open
      slotProps={{
        paper: {
          elevation: 4,
          sx: {
            margin: 0,
            maxWidth: 320,
            position: 'absolute',
            top: '15%',
            width: 'calc(100% - 32px)',
          },
        },
      }}
      sx={{ padding: 0 }}
    >
      <DialogContent
        p={2}
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Box alignItems="center" display="flex" flexDirection="column" mb={3}>
          <Box mb={1.5} mt={3} mx={0}>
            <CircularProgress size={24} sx={{ color: 'primary.main' }} />
          </Box>
          <Typography align="center" color="textPrimary" variant="h6">
            {message}
          </Typography>
        </Box>
        <Divider
          mx="auto"
          my={2}
          sx={{
            backgroundColor: 'graphic.light',
            height: 1,
            mb: 2,
            width: '100%',
          }}
        />
        <MagellanLogoColored sx={{ width: 150 }} />
      </DialogContent>
    </Dialog>
  );
};

AuthDialog.propTypes = {
  message: string.isRequired,
};

export default AuthDialog;
